'use client'

import type { ComponentProps } from 'react'
import { useEffect, useRef } from 'react'

/**
 * A muted, looping product video. With reduced motion on, it stays on its first frame.
 */
export function AutoplayVideo(props: Omit<ComponentProps<'video'>, 'autoPlay' | 'muted' | 'loop' | 'playsInline'>) {
  const ref = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const video = ref.current
    if (!video) return
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.pause()
      return
    }
    void video.play().catch(() => undefined)
  }, [])

  return <video ref={ref} muted loop playsInline preload='metadata' {...props} />
}
